module.exports = __webpack_public_path__ + "img/PDF.7a8605db.png";